import type {SvgIconProps} from '@mui/material';
import {SvgIcon} from '@mui/material';
import {memo} from 'react';

export const Pubsub = memo((props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid"
      fill="currentColor"
      {...props}
    >
      <g>
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          fill="#4285F4"
        />
        <circle cx="8" cy="8" r="2" fill="#34A853" />
        <circle cx="16" cy="8" r="2" fill="#FBBC04" />
        <circle cx="12" cy="16" r="2" fill="#EA4335" />
        <path d="M8 10h8v2H8zm0 4h8v2H8z" fill="#4285F4" opacity="0.7" />
      </g>
    </SvgIcon>
  );
});
Pubsub.displayName = 'Pubsub';
